import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "history";

/**
 * Parameters required to build Corporate Workflows breadcrumb
 */
export interface CorporateWorkflowsBreadcrumbParams {
    customerTitle: string;
    appName: string;
    location: Location;
    history: any;
    lastPortfolioIdForChilds: number | null;
}

/**
 * Builds breadcrumb items for Corporate Workflows app
 */
export const buildCorporateWorkflowsBreadcrumb = (
    params: CorporateWorkflowsBreadcrumbParams
): IBreadcrumbItem[] => {

    const {
        customerTitle,
        appName,
        location,
        history,
        lastPortfolioIdForChilds
    } = params;

    const items: IBreadcrumbItem[] = [];

    // --------------------------------------------------------
    // ROOT ITEMS
    // --------------------------------------------------------

    items.push({
        text: 'ZedX Apps',
        key: "root",
        onClick: () => history.push("/")
    });

    items.push({
        text: appName,
        key: "app",
        onClick: () => history.push("/a1/welcome")
    });

    // --------------------------------------------------------
    // DETERMINE CURRENT PATH
    // (supports BrowserRouter & HashRouter)
    // --------------------------------------------------------

    let path = location.pathname || "";
    if ((!path || path === "/") && location.hash) {
        path = location.hash
            .replace(/^#/, "")
            .split("?")[0]
            .split("#")[0];
    }

    // --------------------------------------------------------
    // HELPER ROUTES
    // --------------------------------------------------------

    const workstreamsRoute = lastPortfolioIdForChilds
        ? `/a1/workflows-for-portfolio/${lastPortfolioIdForChilds}`
        : `/a1/workflows`;

    // --------------------------------------------------------
    // ROUTE-SPECIFIC BREADCRUMB ITEMS
    // --------------------------------------------------------

    if (path === "/a1/welcome") {
        items.push({ text: "Welcome", key: "welcome", isCurrentItem: true });
    }
    else if (path === "/a1/insights") {
        items.push({ text: "Insights", key: "insights", isCurrentItem: true });
    }
    else if (path.startsWith("/a1/cwf-portfolios")) {
        items.push({ text: "Portfolios", key: "portfolios", isCurrentItem: true });
    }
    else if (path === "/a1/workflows") {
        items.push({
            text: "Workstreams",
            key: "workstreams",
            isCurrentItem: true
        });
    }
    else if (path.startsWith("/a1/workflows-for-portfolio")) {
        items.push({
            text: "Portfolios",
            key: "portfolios",
            onClick: () => history.push("/a1/cwf-portfolios")
        });
        items.push({
            text: "Workstreams",
            key: "workstreams",
            isCurrentItem: true
        });
    }
    else if (path.startsWith("/a1/epics")) {
        if (lastPortfolioIdForChilds) {
            items.push({
                text: "Portfolios",
                key: "portfolios",
                onClick: () => history.push("/a1/cwf-portfolios")
            });
        }
        items.push({
            text: "Workstreams",
            key: "workstreams",
            onClick: () => history.push(workstreamsRoute)
        });
        items.push({ text: "Epics", key: "epics", isCurrentItem: true });
    }
    else if (path.startsWith("/a1/workflow-users")) {
        if (lastPortfolioIdForChilds) {
            items.push({
                text: "Portfolios",
                key: "portfolios",
                onClick: () => history.push("/a1/cwf-portfolios")
            });
        }
        items.push({
            text: "Workstreams",
            key: "workstreams",
            onClick: () => history.push(workstreamsRoute)
        });
        items.push({ text: "Users", key: "users", isCurrentItem: true });
    }
    else if (path.startsWith("/a1/workflow-tasks")) {
        if (lastPortfolioIdForChilds) {
            items.push({
                text: "Portfolios",
                key: "portfolios",
                onClick: () => history.push("/a1/cwf-portfolios")
            });
        }
        items.push({
            text: "Workstreams",
            key: "workstreams",
            onClick: () => history.push(workstreamsRoute)
        });
        items.push({ text: "Work Items", key: "workitems", isCurrentItem: true });
    }
        else if (path === "/a1/settings/templates") {
        items.push({
            text: "Settings",
            key: "settings",
            onClick: () => history.push("/a1/settings/templates")
        });
        items.push({
            text: "Templates",
            key: "templates",
            isCurrentItem: true
        });
    }
    else if (path.startsWith("/a1/settings/work-item-types")) {
        items.push({
            text: "Settings",
            key: "settings",
            onClick: () => history.push("/a1/settings/templates")
        });
        items.push({
            text: "Templates",
            key: "templates",
            onClick: () => history.push("/a1/settings/templates")
        });
        items.push({
            text: "Work Item Types",
            key: "work-item-types",
            isCurrentItem: true
        });
    }

    return items;
};
